// src/utils/colorUtils.js

const defaultColorConfig = {
  colors: [
    { min: 0, max: 0, color: "#c8c8c8" },
    { min: 1, max: 80, color: "#ff0000" },
    { min: 81, max: 90, gradient: ["#ff0000", "#00ff00"] },
    { min: 91, max: 100, color: "#00ff00" },
  ],
};

export function hexToRgb(hex) {
  hex = hex.replace(/^#/, "");
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((c) => c + c)
      .join("");
  }
  const num = parseInt(hex, 16);
  return [num >> 16, (num >> 8) & 255, num & 255];
}

export function interpolateColor(start, end, ratio) {
  const result = start.map((startVal, i) => Math.round(startVal + (end[i] - startVal) * ratio));
  return `rgb(${result[0]}, ${result[1]}, ${result[2]})`;
}

export function getDynamicColorForPercentage(percentage, colorConfig) {
  if (!colorConfig || !colorConfig.colors) {
    colorConfig = defaultColorConfig;
  }
  for (const range of colorConfig.colors) {
    if (percentage >= range.min && percentage <= range.max) {
      if (range.color) {
        return range.color;
      } else if (range.gradient) {
        const [startHex, endHex] = range.gradient;
        const startRgb = hexToRgb(startHex);
        const endRgb = hexToRgb(endHex);
        const ratio = (percentage - range.min) / (range.max - range.min);
        return interpolateColor(startRgb, endRgb, ratio);
      }
    }
  }
  return "#FFFFFF"; // fallback
}

export function getStaticColorColorForPercentage(percentage, colorConfig) {
  if (percentage > 90) return "rgb(0, 200, 0)";
  if (percentage > 80) return "rgb(255, 165, 0)";
  if (percentage > 0) return "rgb(255, 0, 0)";
  return "rgb(200, 200, 200)";
}

export function getScaleColorForPercentage(percentage, colorConfig) {
if (percentage > 90) return "rgb(0, 255, 0)";
if (percentage > 85) return "rgb(0, 255, 120)";
if (percentage > 75) return "rgb(0, 255, 255)";
if (percentage > 60) return "rgb(0, 180, 255)";
if (percentage > 50) return "rgb(0, 100, 255)";
if (percentage > 0) return "rgb(0, 0, 255)";
return "rgb(200, 200, 200)";                           
}



// Pomocnicza funkcja, która parsuje ciąg "rgb(r,g,b)" do tablicy [r, g, b]
export function parseRgbString(rgbString) {
  const result = rgbString.match(/\d+/g);
  return result ? result.map(Number) : [0, 0, 0];
}

// Funkcja ustalająca kontrastujący kolor tekstu – przyjmuje wejście jako tablicę lub jako string "rgb(...)"
export function getContrastingTextColor(input) {
  let rgb;
  if (typeof input === "string") {
    rgb = parseRgbString(input);
  } else if (Array.isArray(input)) {
    rgb = input;
  } else {
    rgb = [255, 255, 255];
  }
  const [red, green, blue] = rgb;
  // Obliczamy jasność przy użyciu wzoru luminancji
  const brightness = red * 0.299 + green * 0.587 + blue * 0.114;
  // Jeśli jasność jest wysoka – zwracamy ciemny tekst, w przeciwnym razie biały
  return brightness > 146 ? "rgb(34,34,34)" : "rgb(255,255,255)";
}

/*
#ff0000
#ffff00
#00ff00 
*/
